import React from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import "./styles.css";
import { db } from "../../utils/firebase";
import { collection, addDoc, getDoc, doc, updateDoc } from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";

const schema = Yup.object().shape({
  transType: Yup.string().required("Transaction type is required"),
  merchant: Yup.string().required("Merchant is required"),
  amount: Yup.string()
    .trim()
    .matches(/^\d+(\.\d{1,2})?$/, "Not a valid amount")
    .required("Amount is required"),
  category: Yup.string().required("Category is required"),
});

const AddTransactionPageContent = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const { currentUser } = useAuth();
  const [dateVal, setDateVal] = useState();
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors = false, isSubmitted },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const transactionsCollectionRef = collection(db, "transactions");
  const [newType, setNewType] = useState("");
  const [editTrans, setEditTrans] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const createTransaction = async (formValues) => {

    await addDoc(transactionsCollectionRef, {
      date: formValues.date,
      merchant: formValues.merchant,
      amount: parseFloat(formValues.amount).toFixed(2),
      category: formValues.category,
      description: formValues.description,
      type: formValues.transType,
      uId: currentUser.auth.currentUser.uid,
    });
    navigate("/transactions");
  };

  const getTransactionById = async () => {
    const transactionByIdCollectionRef = doc(db, "transactions", id);
    try {
      const docSnap = await getDoc(transactionByIdCollectionRef);
      console.log(docSnap.data());
      if (docSnap.exists()) {
        setEditTrans(docSnap.data());
        setValue("transType", docSnap.data().type);
        setValue("date", docSnap.data().date);
        setValue("amount", docSnap.data().amount);
        setValue("category", docSnap.data().category);
        setValue("merchant", docSnap.data().merchant);
        setValue("description", docSnap.data().description);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const editTransaction = async (formValues) => {
    const editTransactionRef = doc(db, "transactions", id);
    try {
      const docSnap = await getDoc(editTransactionRef);
      console.log(docSnap.data());
      if (docSnap.exists()) {
        await updateDoc(editTransactionRef, {
          date: formValues.date,
          merchant: formValues.merchant,
          amount: parseFloat(formValues.amount).toFixed(2),
          category: formValues.category,
          description: formValues.description,
          type: formValues.transType,
        });
        navigate("/transactions");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id) {
      getTransactionById();
    } else {
      reset();
      //set the default form date to the current date
      var dateVal = new Date().toLocaleDateString("en-US").split("T")[0];
      // var formattedDate = dateVal.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3");
      var dateArr = dateVal.split('/');
      var formattedDate = dateArr[2] + '-' + dateArr[0] + '-' + (dateArr[1] < 10 ? '0' + dateArr[1] : dateArr[1]);
      setDateVal(formattedDate);
      setValue("date", formattedDate);
    }
  }, []);

  const onSubmit = (formValues) => {
    setButtonDisabled(true);

    console.log(formValues);
    if (id) {
      editTransaction(formValues);
    } else {
      createTransaction(formValues);
    }
  };

  return (
    <div className="formBody">
      <div className="row">
        <div className="col-md-6 text-left">
          {id ? (
            <>
              <h1>Edit Transaction</h1>
              <br />
            </>
          ) : (
            <>
                <h1>Add Transaction</h1>
                <p><em>Input transaction details to successfully add it.</em></p>
              <br />
            </>
          )}
        </div>
      </div>
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label>
                Date<span className="required">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                defaultValue={dateVal}
                {...register("date")}
              />
            </div>

            <div className="form-group col-md-6">
              <label>
                Type<span className="required">*</span>
              </label>
              <select
                className={
                  errors?.transType?.message && isSubmitted
                    ? "form-select error"
                    : "form-select form-control"
                }
                {...register("transType")}
                onChange={(event) => {
                  setNewType(event.target.value);
                  setValue("category", "");
                }}
              >
                <option value=""></option>
                <option value="Expense">Expense</option>
                <option value="Income">Income</option>
              </select>
              <span className="error">{errors?.transType?.message}</span>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label>
                Merchant<span className="required">*</span>
              </label>
              <input
                type="text"
                className={
                  errors?.merchant?.message && isSubmitted
                    ? "form-control error"
                    : "form-control"
                }
                {...register("merchant")}
              />
              <span className="error">{errors?.merchant?.message}</span>
            </div>
            <div className="form-group col-md-6">
              <label>
                Amount<span className="required">*</span>
              </label>
              <input
                className={
                  errors?.amount?.message && isSubmitted
                    ? "form-control error"
                    : "form-control"
                }
                {...register("amount")}
              />
              <span className="error">{errors?.amount?.message}</span>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <label>
                Category<span className="required">*</span>
              </label>
              <select
                className={
                  errors?.category?.message && isSubmitted
                    ? "form-select error"
                    : "form-select"
                }
                {...register("category")}
              >
                <option value=""></option>
                {newType === "Expense" || newType === "" ? (
                  <option value="Donation">Donation</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Education">Education</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Entertainment">Entertainment</option>
                ) : null}
                {newType === "Income" || newType === "" ? (
                  <option value="Gift">Gift</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Groceries">Groceries</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Housing">Housing</option>
                ) : null}
                {newType === "Income" || newType === "" ? (
                  <option value="Investment">Investment</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Medical">Medical</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Pets">Pets</option>
                ) : null}
                {newType === "Income" || newType === "" ? (
                  <option value="Refund">Refund</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Reimbursement">Reimbursement</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Restaurant">Restaurant</option>
                ) : null}
                {newType === "Income" || newType === "" ? (
                  <option value="Salary">Salary</option>
                ) : null}
                {newType === "Income" || newType === "" ? (
                  <option value="Sold Items">Sold Items</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Technology">Technology</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Utilities">Utilities</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Vacation">Vacation</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Work">Work</option>
                ) : null}
                {newType === "Expense" || newType === "" ? (
                  <option value="Other Expense">Other Expense</option>
                ) : null}
                {newType === "Income" || newType === "" ? (
                  <option value="Other Income">Other Income</option>
                ) : null}
              </select>
              <span className="error">{errors?.category?.message}</span>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-12">
              <label>Description</label>
              <textarea
                className={"form-control"}
                {...register("description")}
                rows="5"
              />
            </div>
          </div>
          <div>
            <Link to="/transactions" className="btn btn-secondary float-right">
              Cancel
            </Link>
            {id && editTrans ? (
              <button
                type="submit"
                className="btn btn-primary float-right mr-2"
              >
                Edit
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-success float-right mr-2"
                disabled={buttonDisabled}
              >
                Create
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTransactionPageContent;